import { jsx } from "react/jsx-runtime";
import { CheckboxFieldWUT } from "../../../ui/checkbox-field/checkbox-field-wut.js";
import { FIELD_TYPES } from "../../../constants/field-types.js";
const ContactsSubscribeWUT = (props) => {
  const fieldType = FIELD_TYPES.CONTACTS_SUBSCRIBE;
  return /* @__PURE__ */ jsx(CheckboxFieldWUT, { ...props, fieldType });
};
export {
  ContactsSubscribeWUT
};
//# sourceMappingURL=contacts-subscribe-wut.js.map
